import { inject, Injectable } from '@angular/core';
import {
  VerticalConfig,
  VerticalConfigResolver,
} from '@callrail/looky/vertical-label';

import { SignalContextService } from './signal-context.service';

@Injectable({
  providedIn: 'root',
})
export class SignalContextVerticalConfigResolver extends VerticalConfigResolver {
  private context = inject(SignalContextService);

  public override resolve(): VerticalConfig | undefined {
    return this.context.agency()?.vertical_config;
  }
}
